import BannerManager from "./BannerManager";
import { BANNER_TYPES } from "../Utils/constant";

function Banners() {
  return (
    <BannerManager
      bannerType={BANNER_TYPES.PRIMARY}
      title="Primary Banner"
      description="Add portrait banners and drag them in the row below to set display order. Inactive banners are hidden from the shop app."
    />
  );
}

export default Banners;
